var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___dms5RV",
  "cU": "UserArea.module__userAreaContainer___dms5RV",
  "jC": "UserArea.module__popoutContainer___dms5RV",
  "oT": "UserArea.module__voiceConnectionWrapper___dms5RV",
  "eF": "UserArea.module__userInfo___dms5RV",
  "vu": "UserArea.module__active___dms5RV",
  "N6": "UserArea.module__userInfoText___dms5RV",
  "nT": "UserArea.module__userName___dms5RV",
  "ag": "UserArea.module__userStatus___dms5RV",
  "uh": "UserArea.module__userStatusLabel___dms5RV" + " " + "UserArea.module__userStatus___dms5RV",
  "XW": "UserArea.module__userCustomStatus___dms5RV" + " " + "UserArea.module__userStatus___dms5RV",
  "oM": "UserArea.module__hoverRoll___dms5RV",
  "n6": "UserArea.module__defaultState___dms5RV",
  "yo": "UserArea.module__hovered___dms5RV",
  "EE": "UserArea.module__forceHover___dms5RV",
  "gO": "UserArea.module__controlsContainer___dms5RV",
  "uH": "UserArea.module__controlButton___dms5RV",
  "DY": "UserArea.module__contextMenuHover___dms5RV",
  "r9": "UserArea.module__disabled___dms5RV",
  "pd": "UserArea.module__controlIcon___dms5RV",
  "se": "UserArea.module__controlIconWithDot___dms5RV",
  "PP": "UserArea.module__controlDot___dms5RV",
};

module.exports = exports;
